// core/wdd.js
import * as utils from '../utils/index.js';

if (window.WDD) throw new Error("Warning! WDD JS object already exists! Script was loaded multiple times?");
export const WDD = { data: {}, utils };
window.WDD = WDD;